var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLoxam4ColorBgWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 24,
    viewBox: "0 0 140 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO_LOXAM_4COLOR_BG_WHITE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.07 16.0749H9.49316L7.17619 12.0041L9.49316 7.96584H11.1665L9.30008 4.87204L11.1665 1.74567H5.8568L0 12.0041L5.8568 22.295H11.1987L13.0008 19.2338L11.07 16.0749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.4595 12.0041L17.6027 1.74567H12.4861L10.6196 4.87204L12.4861 7.96584H14.0951L16.4121 12.0041L14.0951 16.0749H12.4217L14.3204 19.2338L12.5183 22.295H17.6027L23.4595 12.0041Z",
    fill: "#BDBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.9324 1.74567H35.3016V15.6841H41.4802V22.2625H27.9324V1.74567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M54.9961 8.16122C57.3452 8.16122 58.7933 9.98494 58.7933 12.1669C58.7933 14.5117 57.2487 16.1074 54.9961 16.1074C52.7756 16.1074 51.1988 14.5117 51.1988 12.1669C51.1988 9.98494 52.6469 8.16122 54.9961 8.16122ZM54.9961 1.41998C48.8497 1.41998 43.7974 5.62105 43.7974 12.0692C43.7974 18.6476 48.8175 22.5881 54.9961 22.5881C61.1747 22.5881 66.1948 18.6476 66.1948 12.0692C66.1948 5.62105 61.1425 1.41998 54.9961 1.41998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M87.5623 1.74567L81.2228 11.3527L88.4633 22.2625H80.0643L77.7473 17.8986C77.522 17.4752 77.3933 17.0844 77.329 16.6611H77.1037C76.975 17.1496 76.7819 17.6055 76.5245 18.0614L74.2718 22.2625H65.8728L72.9846 11.3527L66.6129 1.74567H74.9154L76.4279 4.64407C76.7175 5.1977 76.8784 5.75133 77.0393 6.33752H77.2002C77.329 5.75133 77.5864 5.1977 77.8438 4.64407L79.2276 1.74567H87.5623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M98.7611 14.8373L100.113 8.58457H100.37C100.499 9.46386 100.628 10.3432 100.853 11.2224L101.722 14.8373H98.7611ZM97.4418 19.7223H103.009L103.685 22.295H111.472L104.232 1.7782H96.0902L89.0427 22.295H96.8303L97.4418 19.7223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M115.463 1.74567H123.057L125.857 12.5251H126.05C126.179 11.6133 126.307 10.6689 126.565 9.78956L128.85 1.74567H136.348L139.694 22.2625H132.582L131.585 11.0271H131.456C131.327 11.711 131.199 12.4274 130.973 13.0788L128.045 22.2625H123.733L121.094 13.5673C120.869 12.688 120.676 11.8738 120.644 10.9945H120.386C120.322 11.8087 120.29 12.6554 120.193 13.4696L119.324 22.2299H112.212L115.463 1.74567Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoxam4ColorBgWhite);
export default __webpack_public_path__ + "static/media/LOGO_LOXAM_4COLOR_BG_WHITE.b72746c3503375b2cde10f2a969bd68f.svg";
export { ForwardRef as ReactComponent };